module.exports = __webpack_public_path__ + "static/media/create-campaign-icon.a0908c3a.svg";